package com.vamvisions.main.portfolio.data.repository

import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.Result
import com.vamvisions.main.core.domain.map
import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.portfolio.data.mapper.toProject
import com.vamvisions.main.portfolio.data.remote.PortfolioApi
import com.vamvisions.main.portfolio.domain.model.Project
import com.vamvisions.main.portfolio.domain.repository.ProjectRepository

/** Fetches the projects from the server on every call; nothing is cached. */
class RemoteProjectRepository(private val api: PortfolioApi) : ProjectRepository {

    override suspend fun get(language: Language): Result<List<Project>, DataError.Network> =
        api.getProjects(language).map { response -> response.items.map { it.toProject() } }
}
